/*
 * @Description: 常量
 * @Date: 2024-11-07 15:21:16
 */

/**
 * 右侧标题
 */
export const APP_NAME = '营销服务 SaaS 业务平台';

/**
 * 右侧盒子类型
 */
export enum LoginTypeEnum {
  /**
   * 注册
   */
  REGISTER = 'REGISTER',
  /**
   * 设置密码（点击立即注册按钮后）
   */
  SETPWD = 'SETPWD',
  /**
   * 验证码登录、密码登录
   */
  MAIN = 'MAIN',
  /**
   * 验证手机号（点击忘记密码后）
   */
  FORGET = 'FORGET',
  /**
   * 重置密码
   */
  RESET = 'RESET',
  /**
   * 重置密码成功
   */
  RESETSUCCESS = 'RESETSUCCESS'
}

/**
 * 表单数据项
 */
export enum FormItemEnum {
  /**
   * 手机
   */
  phone = 'phone',
  /**
   * 验证码
   */
  code = 'verifyCode',
  /**
   * 账号
   */
  account = 'userName',
  /**
   * 密码
   */
  pwd = 'password',
  /**
   * 重置密码输入框2
   */
  pwd2 = 'passwordTwo',
  /**
   * 协议选中状态
   */
  agreement = 'agreement'
}

/**
 * 协议选中状态标识
 */
export enum AgreementEnum {
  /**
   * 选中
   */
  TRUE = 1,
  /**
   * 未选中
   */
  FALSE = 0
}
